import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

export type DiscountMode = "items" | "bill";

interface DiscountModeTabsProps {
  mode: DiscountMode;
  onChange: (mode: DiscountMode) => void;
  /** Подсказката, когато „На цялата сметка" е заключено (локален режим). */
  billLockedHint?: string;
}

/** Двата вида отстъпка в модала „Отстъпки" — „По продукти" (%) и „На цялата
 *  сметка" (€). Същите сегменти като бързите проценти отдолу, по-високи. */
export const DiscountModeTabs = ({
  mode,
  onChange,
  billLockedHint,
}: DiscountModeTabsProps) => {
  const { t } = useTranslation();
  const tabs: { value: DiscountMode; label: string; hint?: string }[] = [
    { value: "items", label: t("itemDiscounts.modeItems") },
    { value: "bill", label: t("itemDiscounts.modeBill"), hint: billLockedHint },
  ];

  return (
    <div className="grid grid-cols-2 gap-1 rounded-xl bg-pos-line2 p-1">
      {tabs.map((tab) => {
        const isActive = mode === tab.value;
        const button = (
          <button
            type="button"
            onClick={() => onChange(tab.value)}
            disabled={!!tab.hint}
            className={`h-10 w-full cursor-pointer rounded-[9px] border-0 px-2 text-[13.5px] font-bold transition-colors disabled:cursor-not-allowed disabled:opacity-45 ${
              isActive
                ? "bg-pos-card text-pos-accent-ink shadow-sm"
                : "bg-transparent text-pos-soft2 enabled:hover:text-pos-ink"
            } ${tab.hint ? "pointer-events-none" : ""}`}
          >
            {tab.label}
          </button>
        );
        // Заключеното е disabled — подсказката е на обвивката (disabled бутон
        // не получава mouse събития), като в лентата с действията.
        return tab.hint ? (
          <Tooltip key={tab.value} title={tab.hint}>
            <span className="flex cursor-not-allowed">{button}</span>
          </Tooltip>
        ) : (
          <span key={tab.value} className="flex">
            {button}
          </span>
        );
      })}
    </div>
  );
};
